import { configureStore } from '@reduxjs/toolkit';
import audioPlayerReducer from './features/audioPlayer/audioPlayerSlice';
import selectedThemeReducer from './features/selectedTheme/selectedTheme';
import dialogControlReducer from './features/dialogControl/dialogControlSlice';
import emailReducer from './features/email/emailSlice';
import toastMiddleware from "./services/toastMiddleware";
import userReducer from './features/user/userSlice';

export const store = configureStore({
  reducer: {
    audioPlayer: audioPlayerReducer, 
    selectedTheme: selectedThemeReducer, 
    dialogControl: dialogControlReducer,
    email: emailReducer,
    user: userReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(toastMiddleware),
});

export default store;